import React, { useState, useEffect } from "react";
import "../../../assets/styles/pages/Relatorio/PowerBI.scss";
import InputForm from "../../Form/InputForm.js";
import business from "../../../services/business.js";
import config from "../../../config/config.js";
import ModalProcessosOperadora from "../../Modais/ModalProcessosOperadora.js";

export default function Geral() {

    const typeProcess = [
        {
            id: 0,
            nome: "Todos"
        },
        {
            id: 1,
            nome: "Segunda opinião"
        },
        {
            id: 2,
            nome: "Consenso pré"
        },
        {
            id: 3,
            nome: "Junta médica ou odontológica"
        }
    ];

    const [filtros, setFiltros] = useState({
        uf: '',
        id_tipo_processo: '',
        id_operadora: '',
        id_especialidade: '',
        id_area_atuacao: '',
        inicio_processo_inicio: '',
        inicio_processo_fim: '',
        data_conclusao_inicio: '',
        data_conclusao_fim: ''
    });

    const [filtro, setFiltro] = useState(false);

    const setModel = async (name, value) => {
        await setFiltros(prev => ({ ...prev, [name]: value }));
    };


    const [listagemEtapas, setListagemEtapas] = useState([]);

    const [dadosStatus, setDadosStatus] = useState([]);
    const [showModalProcessos, setShowModalProcessos] = useState(false);
    const [processoSelecionadoIds, setProcessoSelecionadoIds] = useState([]);
    const [processoSelecionadoTipo, setProcessoSelecionadoTipo] = useState("");
    const [processos, setProcessos] = useState([]);

    const getSearch = async (loading = true) => {
        setLoading(loading);
        const desempenhoOperacional = await business.getDesempenhoOperacional({
            uf: filtros.uf,
            id_tipo_processo: filtros.id_tipo_processo,
            id_operadora: filtros.id_operadora,
            id_especialidade: filtros.id_especialidade,
            id_area_atuacao: filtros.id_area_atuacao,
            inicio_processo_inicio: filtros.inicio_processo_inicio,
            inicio_processo_fim: filtros.inicio_processo_fim,
            data_conclusao_inicio: filtros.data_conclusao_inicio,
            data_conclusao_fim: filtros.data_conclusao_fim,
        });

        const etapasStatus = desempenhoOperacional?.desempenhoOperacionalEtapasStatus || {};
        const contagem = desempenhoOperacional?.desempenhoOperacionalTotais || {};

        setListagemEtapas([
            {
                titulo: "Aguardando aceites",
                valor: etapasStatus.aguardando_aceites,
                ids: etapasStatus.aguardando_aceites_id,
                tipo: etapasStatus.aguardando_aceites_tipo
            },
            {
                titulo: "Aguardando assistente",
                valor: etapasStatus.aguardando_assistente,
                ids: etapasStatus.aguardando_assistente_id,
                tipo: etapasStatus.aguardando_assistente_tipo
            },
            {
                titulo: "Aguardando profissional assistente",
                valor: etapasStatus.aguardando_pa,
                ids: etapasStatus.aguardando_pa_id,
                tipo: etapasStatus.aguardando_pa_tipo
            },
            {
                titulo: "Análise",
                valor: etapasStatus.analise,
                ids: etapasStatus.analise_id,
                tipo: etapasStatus.analise_tipo
            },
            {
                titulo: "Auditoria",
                valor: etapasStatus.auditoria,
                ids: etapasStatus.auditoria_id,
                tipo: etapasStatus.auditoria_tipo
            },
            {
                titulo: "Análise profissional desempatador",
                valor: etapasStatus.analise_pd,
                ids: etapasStatus.analise_pd_id,
                tipo: etapasStatus.analise_pd_tipo
            },
            {
                titulo: "Ciência de abertura",
                valor: etapasStatus.ciencia_abertura,
                ids: etapasStatus.ciencia_abertura_id,
                tipo: etapasStatus.ciencia_abertura_tipo
            },
            {
                titulo: "Ciência de conclusão",
                valor: etapasStatus.ciencia_conclusao,
                ids: etapasStatus.ciencia_conclusao_id,
                tipo: etapasStatus.ciencia_conclusao_tipo
            },
            {
                titulo: "Devolvido para säästö",
                valor: etapasStatus.devolvido,
                ids: etapasStatus.devolvido_id,
                tipo: etapasStatus.devolvido_tipo
            },
            {
                titulo: "Pendência administrativa ou técnica",
                valor: etapasStatus.info_doc_pendentes,
                ids: etapasStatus.info_doc_pendentes_id,
                tipo: etapasStatus.info_doc_pendentes_tipo
            },
            {
                titulo: "Validação",
                valor: etapasStatus.validacao,
                ids: etapasStatus.validacao_id,
                tipo: etapasStatus.validacao_tipo
            }
        ]);
        setDadosStatus([
            {
                titulo: "Não Iniciados",
                valor: contagem.nao_iniciados
            },
            {
                titulo: "Em andamento",
                valor: contagem.andamento
            },
            {
                titulo: "Atrasados",
                valor: contagem.atrasados
            },
            {
                titulo: "Finalizados",
                valor: contagem.finalizados
            },
            {
                titulo: "Cancelados",
                valor: contagem.cancelados
            },
            {
                titulo: "Total",
                valor: contagem.total
            }
        ]);

        setProcessos(desempenhoOperacional?.desempenhoListaAtrasados);

        setLoading(false);
        setSearchLoading(false);
    };

    // eslint-disable-next-line 
    const [searchLoading, setSearchLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const limparFiltros = () => {
        setFiltros({});
        setFiltros(false);
        window.location.reload();
    }

    useEffect(() => {
        (async () => {
            await getSearch();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const searchOperadora = async (e) => {
        e.preventDefault();
        return await business.getOperadora(e.target.value);
    }

    const searchEspecialidade = async (e) => {
        e.preventDefault();
        return await business.getEspecialidade(e.target.value);
    };

    const searchAreaAtuacao = async (e) => {
        e.preventDefault();
        return await business.getAreaAtuacao(e.target.value, 12, 1, filtros?.id_especialidade);
    };

    const hideModalProcessos = async (event) => {
        event?.preventDefault();
        setShowModalProcessos(false);
    };

    return (
        <>
            {showModalProcessos && (
                <ModalProcessosOperadora
                    show={showModalProcessos}
                    hideModal={hideModalProcessos}
                    etapaIds={processoSelecionadoIds}
                    tipo={processoSelecionadoTipo}
                    listaProcessos={processos}
                />
            )}

            <div className="flex ai-fc gap-30 w-100 mb-30 mt-20 justify-content-end">

                <button className={`btn btn-${!filtro ? `outline-` : ''}primary filtros f700-16 jc-sb me-4`} onClick={() => setFiltro(!filtro)}>
                    <span className="desktop">Filtrar </span> <i className={`icon ${!filtro ? `icon-settings-sliders ` : `icon-exit `}i-20 ml-5 blue`} />
                </button>

            </div>
            {filtro && <div className="filtro-consulta form-container grid col-12 mb-30">
                <div className="w-100">
                    <div className="grid col-12 md-gap mb-20">
                        <InputForm
                            label="Tipo de processo"
                            required
                            type="select"
                            className="span-3"
                            name="id_tipo_processo"
                            options={typeProcess}
                            value={filtros?.id_tipo_processo}
                            model={(name, id) => {
                                const selectedProcess = typeProcess.find(process => process.id === Number(id));
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_tipo_processo: selectedProcess?.id || ''
                                }));
                            }}
                        />

                        {config.isSaastoUser() && <InputForm
                            label="Operadora"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchOperadora}
                            name="id_operadora"
                            model={(...params) => {
                                const idOperadora = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_operadora: idOperadora
                                }));
                            }}
                        />}

                        <InputForm
                            label="Especialidade"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchEspecialidade}
                            name="id_especialidade"
                            model={(...params) => {
                                const idEspecialidade = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_especialidade: idEspecialidade
                                }));
                            }}
                        />

                        <InputForm
                            label="Área de atuação"
                            type="search"
                            className="span-3"
                            placeholder="Pesquisar..."
                            onSearch={searchAreaAtuacao}
                            name="id_area_atuacao"
                            model={(...params) => {
                                const idAreaAtuacao = params[0]?.id;
                                setFiltros(prevState => ({
                                    ...prevState,
                                    id_area_atuacao: idAreaAtuacao
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="w-100">
                    <div className="grid col-12">
                        <InputForm label="Data de início (Inicial)" type="date" id="inicio_processo_inicio" name="inicio_processo_inicio" model={setModel} value={filtros.inicio_processo_inicio} />
                        <span className="text-center interval">-</span>
                        <InputForm className="input-padding" label="Data de início (Final)" type="date" id="inicio_processo_fim" name="inicio_processo_fim" model={setModel} value={filtros.inicio_processo_fim} />
                        <InputForm
                            label="Data de conclusão (Inicial)"
                            type="date"
                            id="data_conclusao_inicio"
                            name="data_conclusao_inicio"
                            model={setModel}
                            value={filtros.data_conclusao_inicio}
                        />
                        <span className="text-center interval">-</span>
                        <InputForm
                            className="input-padding"
                            label="Data de conclusão (Final)"
                            type="date"
                            id="data_conclusao_fim"
                            name="data_conclusao_fim"
                            model={setModel}
                            value={filtros.data_conclusao_fim}
                        />
                        <button className="btn btn-primary f700-16 button-filtrar" onClick={() => {
                            getSearch(1, filtros?.texto || '', true);
                        }}>
                            Aplicar filtros
                        </button>
                        <span className="pointer float-right ml-10 mt-30" onClick={limparFiltros}>
                            <i className="icon icon-trash watermelon i-25" title="Limpar filtros" />
                        </span>
                    </div>
                </div>
            </div>}
            {
                loading ? (
                    <div className="loader loader-default is-active" />
                ) : (
                    <div className="iframe-wrapper mt-5">
                        <div className="text-center">
                            <div className="row align-items-start">
                                <div className="row w-100 grid col-12">
                                    <div className="col-12">
                                        <div className="text-center d-flex justify-content-center">
                                            <div className="row row-cols-6 g-1 align-items-start">
                                                {dadosStatus.map((item, index) => (
                                                    <div
                                                        className={`col ${item.titulo === "Atrasados" ? "pointer" : ""}`}
                                                        key={index}
                                                        onClick={() => {
                                                            if (item.titulo !== "Atrasados") return;
                                                            setProcessoSelecionadoIds("");
                                                            setProcessoSelecionadoTipo("");
                                                            setShowModalProcessos(true);
                                                        }}
                                                    >
                                                        <div style={{ height: "90px" }} className="text-bg-light mb-2 border rounded p-5">
                                                            <h1 className="text-primary">{item.valor}</h1>
                                                            <p>{item.titulo}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="relatorio-operacional-bloco mt-50 mb-50">
                                            <h1 className="title mb-20 relatorio-operacional-titulo">Processos por andamento</h1>
                                            <div className="relatorio-operacional-tabela border-bi">
                                                {!listagemEtapas || !listagemEtapas.length ? (
                                                    <p className="text-center p-20">Não há processos</p>
                                                ) : (
                                                    <>
                                                        <div className="grid col-12 fb-16 relatorio-operacional-header relatorio-operacional-header--columns">
                                                            <div className="span-5 relatorio-operacional-cell">
                                                                Andamento
                                                            </div>
                                                            <div className="span-4 relatorio-operacional-cell">
                                                                Total de processos
                                                            </div>
                                                            <div className="span-3 relatorio-operacional-cell">
                                                                Ações
                                                            </div>
                                                        </div>

                                                        {listagemEtapas.map((etapa, i) => {
                                                            return (
                                                                <div key={i} className="grid col-12 relatorio-operacional-row">
                                                                    <div className="span-5 relatorio-operacional-cell">
                                                                        {etapa.titulo}
                                                                    </div>
                                                                    <div className="span-4 relatorio-operacional-cell">
                                                                        {etapa.valor > 0 ? etapa.valor : '-'}
                                                                    </div>
                                                                    <div className="span-3 relatorio-operacional-cell">
                                                                        {etapa.valor > 0 && (
                                                                            <button
                                                                                className="btn btn-outline-primary"
                                                                                onClick={() => {
                                                                                    setProcessoSelecionadoIds(etapa.ids);
                                                                                    setProcessoSelecionadoTipo(etapa.tipo);
                                                                                    setShowModalProcessos(true);
                                                                                }}
                                                                            >
                                                                                Ver processos
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
}